import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppNavbar from "./Navbar";
import Footer from "./Footer";
import ApprovalBanner from "./ApprovalBanner";

import MobileBottomNavbar from "./MobileBottomNavbar";
import CookieBanner from "./CookieBanner";

const Layout = () => {
  const location = useLocation();
  const isChatPage = location.pathname.startsWith("/chat");
  const isProductDetailPage =
    /^\/products\/[^/]+$/.test(location.pathname) && !location.pathname.endsWith("/add");
  const isCartPage = location.pathname === "/cart";
  const hideMobileBottomNav = isChatPage || isProductDetailPage || isCartPage;

  return (
    <div className="flex flex-col min-h-screen bg-theme-bg">
      {!isChatPage && <AppNavbar />}
      <main
        className={
          isChatPage
            ? "flex-grow h-[100dvh] overflow-hidden"
            : hideMobileBottomNav
            ? "flex-grow"
            : "flex-grow pb-16 lg:pb-0"
        }
      >
        <Outlet />
      </main>
      {!isChatPage && <Footer />}
      {!isChatPage && <ApprovalBanner />}
      {!hideMobileBottomNav && <MobileBottomNavbar />}
      {!isChatPage && <CookieBanner />}
    </div>
  );
};

export default Layout;

